<app-header></app-header>
<app-product-detail></app-product-detail>
<app-other-product></app-other-product>
<app-footer></app-footer>